import React, { useEffect, useState } from "react";
import localeText from "../../../../locale";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import OrderService from "../../../../service/OrderService";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { formatDate } from "../../../../utilities/formatDate";
import { AdvancedImage } from "@cloudinary/react";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import { DataTable } from "primereact/datatable";
import { FilterMatchMode } from "primereact/api";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { formatPrice } from "../../../../utilities/formatPrice";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import UserInitialsAvatar from "../../../../components/UserInitialsAvatar/UserInitialsAvatar";

const FringeBenefitsSales = () => {
  const { showErrorToast, showSuccessToast } = useToastContext();
  const [sales, setSales] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [actualOrder, setActualOrder] = useState();
  const [voucherCode, setVoucherCode] = useState("");
  const [isLoadingUseVoucher, setIsLoadingUseVoucher] = useState(false);

  const filters2 = {
    id: { value: null, matchMode: FilterMatchMode.CONTAINS },
    "fringeBenefit.user.username": { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    status: { value: null, matchMode: FilterMatchMode.EQUALS },
    formatedDate: { value: null, matchMode: FilterMatchMode.EQUALS },
  };

  const orderService = new OrderService();

  const getSales = async () => {
    try {
      setIsLoading(true);

      const res = await orderService.getFringeBenefitsSales();

      if (res.messageCode !== 200001) {
        showErrorToast({ code: res.messageCode });
        return;
      }

      setSales(res.result);
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  const openVoucherModal = (order) => {
    setOpenModal(true);
    setActualOrder(order);
  };

  const voucherUse = async () => {
    try {
      setIsLoadingUseVoucher(true);

      if (voucherCode.length === 0) {
        showErrorToast({ detail: "fillAllFields" });
        return;
      }

      const res = await orderService.getUseFringeBenefits(
        actualOrder.fringeBenefit.user.username,
        voucherCode
      );

      if (res.messageCode !== 200000) {
        showErrorToast({ code: res.messageCode });
        return;
      }

      showSuccessToast({ detail: "wasDischargedFromFringeBenefit" });
      setOpenModal(false);
    } finally {
      setIsLoadingUseVoucher(false);
    }
  };

  useEffect(() => {
    getSales();
  }, []);

  return (
    <div>
      {openModal && (
        <Dialog
          header={localeText("fringeBenefits")}
          visible={openModal}
          className="w-30rem m-2"
          onHide={() => {
            if (!isLoadingUseVoucher) setOpenModal(false);
          }}
          draggable={false}
        >
          <div className="">
            <p className="mb-4">{localeText("doYouWantToCancelTheProductBelow")}</p>
            <p className="mb-0">
              <AdvancedImage
                cldImg={cloudinaryInstance
                  .image(actualOrder.fringeBenefit.imageid1)
                  .resize(fill().width(50).height(50))
                  .format("webp")}
                style={{ outline: "1px solid #e0e0e0", outlineOffset: "4px" }}
                className="border-round mr-3"
                height={50}
              />
            </p>
            <p className="mb-0">Order Id: {actualOrder.id}</p>
            <p className="mb-0">
              {localeText("product")}: {actualOrder.fringeBenefit.title}
            </p>
            <p className="mb-0">
              {localeText("buyer")}: {actualOrder.buyer.firstname} {actualOrder?.buyer?.surname} (
              {actualOrder?.buyer?.username})
            </p>
            <p className="mb-0">
              {localeText("quantity")}: {actualOrder.quantity} {localeText("associatedVoucher")}
            </p>
            <p className="mb-3">
              {localeText("total")}: {actualOrder.fringeBenefit.currency}{" "}
              {formatPrice(actualOrder.totalOrder)}
            </p>
            <div>
              <div className="mb-2">
                <label>{localeText("fringeBenefit")} Voucher</label>
              </div>
              <InputText value={voucherCode} onChange={(e) => setVoucherCode(e.target.value)} />
            </div>
            <div className="flex gap-2 justify-content-end">
              <Button
                onClick={voucherUse}
                loading={isLoadingUseVoucher}
                label={localeText("yes")}
              />
            </div>
          </div>
        </Dialog>
      )}

      <div className="card border-1 border-300">
        <h3 className="my-4">{localeText("sales")}</h3>
        <hr />

        <DataTable
          value={sales}
          paginator
          responsiveLayout="scroll"
          loading={isLoading}
          filters={filters2}
          filterDisplay="row"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate={localeText("showingFirstToLast")}
          rows={10}
          rowsPerPageOptions={[10, 20, 50]}
        >
          <Column
            header={localeText("buyerProfilePic")}
            style={{ width: "10%" }}
            body={(order) => {
              return (
                <UserInitialsAvatar
                  avatarUrl={order?.buyer?.urlAvatar}
                  firstName={order?.buyer?.firstname}
                  lastName={order?.buyer?.surname}
                  fullName={order?.buyer?.username}
                  className="layout-dashboard-urlavatar"
                  alt="buyer-avatar"
                />
              );
            }}
          ></Column>
          <Column
            field="id"
            header={"ID"}
            style={{ width: "20%" }}
            filter
            filterPlaceholder={localeText("search")}
            filters={filters2}
            filterDisplay="row"
            sortable
          />
          <Column
            field={"buyer.username"}
            style={{ width: "20%" }}
            header={localeText("buyer")}
            sortable
            filter
            filterPlaceholder={localeText("searchByButer")}
            filters={filters2}
            filterDisplay="row"
          />
          <Column
            header={localeText("preview")}
            body={(order) => {
              return (
                <div className="flex">
                  <AdvancedImage
                    cldImg={cloudinaryInstance
                      .image(order.fringeBenefit.imageid1)
                      .resize(fill().width(50).height(50))
                      .format("webp")}
                    style={{ outline: "1px solid #e0e0e0", outlineOffset: "4px" }}
                    className="border-round mr-3"
                    height={50}
                  />
                </div>
              );
            }}
            style={{ width: "30%" }}
          />
          <Column field="quantity" header={localeText("itemsQuantity")} style={{ width: "10%" }} />
          <Column
            header={localeText("status")}
            body={(order) => {
              return (
                <span
                  className="team-member-role text-0 p-1 border-round"
                  style={{ backgroundColor: order.status === "PAID" ? "#46a748" : "#F7B005" }}
                >
                  {localeText(order.status?.toLowerCase()).toUpperCase()}
                </span>
              );
            }}
            sortable
            field="status"
          ></Column>
          <Column
            header={localeText("total")}
            body={(order) => {
              return (
                <span>
                  {order.fringeBenefit.currency} {formatPrice(order.totalOrder)}
                </span>
              );
            }}
            field="total"
          ></Column>
          <Column
            header={localeText("date")}
            body={(order) => {
              return <p>{formatDate(new Date(order.dateOrder))}</p>;
            }}
            sortable
            field="date"
          />
          <Column
            header={localeText("actions")}
            body={(order) => {
              return (
                <Button
                  onClick={() => openVoucherModal(order)}
                  className="p-button-help p-button-rounded"
                  disabled={order.status !== "PAID"}
                  style={{ textSize: "4em", width: "max-content" }}
                >
                  {localeText("discharge")}
                </Button>
              );
            }}
            field="useVoucher"
          />
        </DataTable>
      </div>
    </div>
  );
};

export default FringeBenefitsSales;
